import { useEffect, useState } from "react";
import { RootState } from "redux/store";
import { Card, Col, Row } from "react-bootstrap";
import { Title, Table } from "components";
import { Link, useNavigate } from "react-router-dom";
import { getOwners } from "redux/slices/Owners";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { FormatDateToDMYH } from "helpers/data/dataHandling";

export function Owners() {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const owners = useAppSelector((state: RootState) => state.owners);

	useEffect(() => {
		dispatch(getOwners({}));
	}, []);

	const columns = [
		{
			Header: "ID",
			accessor: "id",
			defaultCanSort: true,
			width: 70,
		},
		{
			Header: "Name",
			accessor: "name",
			defaultCanSort: true,
			width: 200,
			Cell: (row: any) => <Link to={`/support/owner/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: "comments",
			accessor: "comments",
			defaultCanSort: true,
			width: 1200,
			Cell: (row: any) => <Link to={`/support/owner/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: "Last User Login",
			accessor: "userLastLoginDate",
			defaultCanSort: true,
			width: 200,
			Cell: (row: any) => <Link to={`/support/owner/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: "Created",
			accessor: "created",
			defaultCanSort: true,
			width: 200,
			Cell: (row: any) => <Link to={`/support/owner/${row.cell.row.original.id}`}>{FormatDateToDMYH(row.value)}</Link>,
		},
	];

	return (
		<>
			<Title pageTitle="Owners" parent="Support" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<Table
										columns={columns}
										data={owners.table}
										pageSize={15}
										isSortable={true}
										pagination={true}
										isSelectable={true}
										isSearchable={true}
										addNewRow={() => navigate(`/support/owner/`)}
										reloadTableRows={() => dispatch(getOwners())}								
									/>
								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}